import { PlanHandleStepComponent } from "../components";
import { connect } from "react-redux";
import { GetDataPlanHandleStepPlanHandleAction, SetDataPlanHandleStepPlanHandleAction, ClearDataPlanHandleStepPlanHandleAction,
     DownloadFileAction, UploadFilePlanHandleAction,
     GetDataHistory,GetStatusActionHistory, GetDataEmailAzureAction } from "../actions";

const mapStateToProps = state => {
    
    return {
        ...state,
        DataPlanHandleStep: state.allPlanHandleReducers.planHandleStepReducer.DataPlanHandleStep,
        DataHandleStaff: state.allPlanHandleReducers.planHandleStepHandleStaffReducer.DataHandleStaff,
        DataHistory: state.allPlanHandleReducers.HistoryReducer.DataHistory,
        StatusActionHistory: state.allPlanHandleReducers.Status_ActionHistory.StatusActionHistory,
        isResult: state.allPlanHandleReducers.isResultReducer.isResult,
        DataFile: state.allPlanHandleReducers.fileReducer.DataFile,
        DataEmailAzure: state.allPlanHandleReducers.DataEmailAzureByNameReducer.DataEmailAzure
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataPlanHandleStep: (ID, Step) => {
            dispatch(GetDataPlanHandleStepPlanHandleAction(ID, Step));
        },
        SetDataPlanHandleStep: (DataPlanHandleStep) => {
            dispatch(SetDataPlanHandleStepPlanHandleAction(DataPlanHandleStep));
        },
        ClearDataPlanHandleStep: () => {
            dispatch(ClearDataPlanHandleStepPlanHandleAction());
        },
        UploadFile: (File, Index) => {
            dispatch(UploadFilePlanHandleAction(File, Index));
        },
        DownloadFile: (value) => {
            dispatch(DownloadFileAction(value));
        },
        GetHistoryByPlanID: (planID) => {
            //console.log("planID", planID)
            dispatch(GetDataHistory(planID));
        },
        GetStatusActionHistory: (planID) => {
            //console.log("container/GetStatusActionHistory", planID);
            dispatch(GetStatusActionHistory(planID));
        },
        GetDataEmailAzureByName: (DataEmailAzure) => { 
            dispatch(GetDataEmailAzureAction(DataEmailAzure)); 
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanHandleStepComponent);